
  import {
    loadLeanDataBookIt,
    submitHandlerRegister,
  } from '@/plugins/tracking/leandata-bookit.js'

  export default {
    name: 'HubspotForm',
    props: {
      slice: {
        type: Object,
        required: true,
        default() {
          return {}
        },
      },
    },
    async fetch() {
      if (!this.slice.primary.embedForm) {
        try {
          // const contact = await fetch(
          //   '/hubspot/contacts/cac8eea7545d21254dddb0ecc2f444a4/profile',
          //   {
          //     headers: {
          //       Authorization: `Bearer ${process.env.HUBSPOT_AUTH_TOKEN}`,
          //     },
          //   }
          // )

          const response = await fetch(
            `/hubspot/forms/${this.options.formId}`,
            {
              headers: {
                Authorization: `Bearer ${this.$config.hubspotAuthToken}`,
              },
            }
          )
          this.form = await response.json()
          if (this.form) {
            console.log(this.form)
            if (this.form.formFieldGroups) {
              this.formFields = this.form.formFieldGroups.map(
                (formFieldGroup) => {
                  if (formFieldGroup.fields[0]) {
                    let field = this.setField(formFieldGroup.fields[0])
                    return field
                  }
                }
              )
              console.log(this.formFields)
              this.formValidation = this.formFields
            }

            if (this.form.metaData) {
              this.consentForm = JSON.parse(
                this.form.metaData.find(
                  (meta) => meta.name === 'legalConsentOptions'
                )?.value
              )
              console.log(this.consentForm)
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    data() {
      return {
        hubspotTrackingId: '',
        options: {
          portalId: this.slice.primary.hubspot_portal_id,
          formId: this.slice.primary.hubspot_form_id,
        },
        formFields: [],
        consentForm: {},
        form: {},
        formValidation: {},
      }
    },
    methods: {
      setField(fieldInfo) {
        let field = {
          name: fieldInfo.name,
          label: fieldInfo.required ? `${fieldInfo.label}*` : fieldInfo.label,
          type: fieldInfo.hidden ? 'hidden' : fieldInfo.fieldType,
          required: fieldInfo.required,
          hidden: fieldInfo.hidden,
          value: '',
          dependentFields: [],
        }

        // dependent fields
        // if(fieldInfo.dependentFieldFilters &&
        //   fieldInfo.dependentFieldFilters.length > 0) {

        //   }

        field.rule = this.setFieldRules(field)

        if (field.type === 'select') {
          field.options = fieldInfo.options.map((option) => {
            return {
              label: option.label,
              value: option.value,
            }
          })
        }

        return field
      },
      setFieldRules(field) {
        let rule = ''
        let rules = []
        let fieldName = field.name.toLowerCase()
        if (field.required) {
          rules.push(' required')
        }

        if (field.type === 'number') {
          rules.push(' numeric')
        }

        if (fieldName.includes('name')) {
          rules.push(' name')
        } else if (fieldName.includes('email')) {
          rules.push(' email')
        } else if (fieldName.includes('phone')) {
          rules.push(' phone')
        } else if (
          fieldName.includes('company') ||
          fieldName.includes('industry')
        ) {
          rules.push(' company')
        } else if (
          fieldName.includes('title') ||
          fieldName.includes('seniority')
        ) {
          rules.push(' alpha_spaces')
        }

        rule = ''
          .concat(...rules)
          .trim()
          .replace(' ', '|')

        return rule
      },
      handleSubmit(event) {
        console.log(event)
      },
      handleFormReady() {
        setTimeout(() => {
          loadLeanDataBookIt(
            window,
            document,
            'https://app.leandata.com/js-snippet/ld_calendaring.js',
            'LDCalendaring'
          )
          LDCalendaring(
            this.$config.leanDataOrgId,
            this.slice.primary.leandata_node_name
          )
          // bind the submit event to handle post-submission events
          const form = document.querySelector(
            `form.hs-form-${this.options.formId}`
          )

          form.addEventListener('submit', this.handleFormSubmitted)
          // api based solution
          // LDCalendaring(
          //     this.$config.leanDataOrgId,
          //     this.slice.primary.leandata_node_name,
          //     false,
          //     {
          //       apiRoutingOn: true,
          //     }
          //   )
        }, 2000)
        submitHandlerRegister('hsFormReadyCallback', this.options.formId)
      },
      handleFormSubmitted() {
        console.log('submitted form')
        // this.$gtag.event('conversion', {
        //   'send_to': `${this.$config.googleAdsId}/XBSJCLSwzeMDEKCSrewC`,
        // })
        if (this.slice.primary.embedForm) {
          // submit trigger the redirect to the bookit calendar page, after 2 seconds to ensure the conversion event was submitted
          if (
            window['LDCalendaring'] &&
            window['LDCalendaring'].hsFormSubmittedCallback
          ) {
            window['LDCalendaring'].hsFormSubmittedCallback()
          }
        }
      },
    },
    mounted() {
      if (typeof window !== 'undefined') {
        this.hubspotTrackingId = this.$cookies.get('hubspotutk')

        if (this.slice.primary.embedForm) {
          window.hbspt.forms.create({
            portalId: this.options.portalId,
            formId: this.options.formId,
            target: '#embedded-form', // notice we target the div id
            onFormReady: this.handleFormReady(),
          })
        }
      }
    },
  }
